import backendPanel from "./backendPanel";
import dashboardPanel from "./dashboardPanel";

export default `
  ${backendPanel}
  ${dashboardPanel}
`;
